import React from 'react';

const FormattedMobile = ({ mobile }) => {
    if (!mobile) {
        return <span>-</span>;
    }

    const formattedMobile = mobile.replace(/^(\d{2})(\d{5})(\d{4})$/, '($1) $2-$3');
    const rawMobile = mobile.replace(/\D/g, ''); // Remove non-digit characters for WhatsApp link
    const whatsappLink = `https://api.whatsapp.com/send?phone=55${rawMobile}`;

    return <span><a href={whatsappLink} target="_blank" rel="noreferrer">{formattedMobile}</a></span>;
};

export default FormattedMobile;